const INTERACTIVE_SELECTOR = 'a, button, input, [role="slider"]';

/**
 * True when the click landed on the video surface rather than a control or
 * in-cue link. Used so play/pause toggles on rage-click-prone overlays
 * without stealing clicks from Skip, the timeline, or caption links.
 */
export function isVideoSurfaceClick(target: EventTarget | null): boolean {
  if (!(target instanceof Element)) return false;
  return !target.closest(INTERACTIVE_SELECTOR);
}
